import Modal from './Modal';
import { Button, Grid, Typography } from '@mui/material';
import warrantyService from '../../services/warranty.service';
import useAlert from '../../hooks/useAlert';
import { WARRANTY_PRODUCT_REQUEST } from '../../error-messages';

type WarrantyNeededModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};
export function WarrantyNeededModal(props: WarrantyNeededModalProps) {
  const alert = useAlert();

  const onRequestInformation = async () => {
    try {
      await warrantyService.createWarrantyRequest();
      props.setOpen(false);
    } catch (err: any) {
      console.log(err);
      alert.setAlert({ message: err.response.data.error ?? WARRANTY_PRODUCT_REQUEST });
    }
  };

  return (
    <Modal title={'Warranty Needed'} open={props.open} setOpen={props.setOpen}>
      <Grid container sx={{ justifyContent: 'center' }} spacing={1}>
        <Grid item>
          <Typography>
            {
              'In order to create work orders, your organization must be a signed up for our warranty product. Please request information below from our sales organization for information on our warranty service.'
            }
          </Typography>
        </Grid>
        <Grid item onClick={onRequestInformation}>
          <Button>Request information</Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
